import AboutPageCmsContainer from "../../container/admin/aboutpage-cms";

const AboutPageCms = () => {
    return <AboutPageCmsContainer />;
};

export default AboutPageCms;